import React from 'react';
import { translate } from 'react-i18next';

import * as Common from 'common/components';

const ProvidersListTable = ({
  children,
  count,
  company,
  subcompany,
  permissions,
  handleToggle = () => {},
  handleOrderChange = () => {},
  order = '',
  orderBy = '',
  t,
}) => {
  const headers = [
    { variable: 'key', text: t('providers.fields.key') + ': ', type: 'h3' },
    { variable: 'name', text: t('providers.fields.name') + ': ' },
    { variable: 'mail', text: t('providers.fields.mail') + ': ' },
    { variable: 'telephone', text: t('providers.fields.telephone') + ': ' },
    { variable: 'rfc', text: t('providers.fields.rfc') + ': ' },
    {
      variable: 'active',
      text: t('providers.fields.active') + ': ',
      boolean: true,
    },
  ];

  const config = {
    actions: t('common.actions'), //Texto de seccion de acciones
    edit: t('common.edit'), //Texto de boton editar
    editPermission: 'acl.providers_clients.update',
    togglePermission: 'acl.providers_clients.toggle',
    editUrl: 'providers', //Url para editar empleado
    propsName: 'provider', //de donde se obtienen los props
    company: company,
    subcompany: subcompany,
  };

  const dataCard = {
    rows: children,
    headers: headers,
    config: config,
    permissions: permissions,
    handleClick: handleToggle,
  };
  return (
    <Common.List dataCard={dataCard}>
      <thead>
        <tr>
          <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="key"
            handleOrderChange={handleOrderChange}
          >
            {t('providers.fields.key')}
          </Common.ThSortable>

          <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="name"
            handleOrderChange={handleOrderChange}
          >
            {t('providers.fields.name')}
          </Common.ThSortable>

          <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="mail"
            handleOrderChange={handleOrderChange}
          >
            {t('providers.fields.mail')}
          </Common.ThSortable>

          <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="telephone"
            handleOrderChange={handleOrderChange}
          >
            {t('providers.fields.telephone')}
          </Common.ThSortable>

          <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="rfc"
            handleOrderChange={handleOrderChange}
          >
            {t('providers.fields.rfc')}
          </Common.ThSortable>

          <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="active"
            handleOrderChange={handleOrderChange}
            className="text-center"
          >
            {t('providers.fields.active')}
          </Common.ThSortable>

          <th className="text-center">{t('common.actions')}</th>
        </tr>
      </thead>

      <tbody>
        {count === 0 && <Common.EmptyTable colSpan={10} />}
        {children}
      </tbody>
    </Common.List>
  );
};

export default translate()(ProvidersListTable);



// WEBPACK FOOTER //
// src/modules/secured/modules/providers/components/list/ProvidersListTable.js